import './style.scss';

let domReady = window?.wp?.domReady;

// Fallback if wp.domReady is not available
if (!domReady) {
  console.warn('wp.domReady not found, using fallback.');
  domReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };
}

// Flip card
function setupCardFlip() {
  const flipButtons = document.querySelectorAll('.card-flip-btn');
  const cards = new Set();

  flipButtons.forEach(button => {
    const card = button.closest('.pat-flip-card');
    if (!card) return;
    cards.add(card);

    button.addEventListener('click', (event) => {
      event.stopPropagation();
      card.classList.toggle('flipped');
    });

    card.addEventListener('mouseleave', () => {
      card.classList.remove('flipped');
    });
  });

  function onDocumentClick(event) {
    cards.forEach(card => {
      if (!card.contains(event.target)) {
        card.classList.remove('flipped');
      }
    });
  }

  document.addEventListener('click', onDocumentClick);
}

domReady(() => {
  setupCardFlip();
});